import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Card, Grid, Icon } from "@mui/material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import MDButton from "shared/components/MDButton";
import CustomModal from "shared/components/MDmodal/CustomModal";
import FormTipoActividad from "../Form/FormTipoActividad";
import { createActivityTypeService } from "modules/bitacora/services/Configuracion/TipoActividad/tipoActividadService";

const HeaderTipoActividad = ({ children, onActivityTypeCreated }) => {
  const [open, setOpen] = useState(false);

  const handleCreate = async (data) => {
    const created = await createActivityTypeService(data);
    onActivityTypeCreated(created);
    setOpen(false);
  };

  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card sx={{ mt: 1, mx: 3, py: 2, px: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" spacing={3}>
          <Grid item>
            <MDTypography variant="h5" fontWeight="medium">
              Actividades
            </MDTypography>
          </Grid>
          <Grid item>
            <MDButton
              variant="gradient"
              color="success"
              startIcon={<Icon>add</Icon>}
              onClick={() => setOpen(true)}
            >
              Crear nuevo Tipo de Actividad
            </MDButton>
          </Grid>
        </Grid>
        {children}
      </Card>
      <CustomModal open={open} onClose={() => setOpen(false)} title="Crear Tipo de Actividad">
        <FormTipoActividad onSubmit={handleCreate} afterSubmit={() => {}} />
      </CustomModal>
    </MDBox>
  );
};

HeaderTipoActividad.defaultProps = {
  children: "",
  onActivityTypeCreated: null,
};

HeaderTipoActividad.propTypes = {
  children: PropTypes.node,
  onActivityTypeCreated: PropTypes.func,
};

export default HeaderTipoActividad;
